<template>
  <div class="yespro" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    

    <div class="pro">
      <div class="goods">
        <img class="left" :src="baseUrl+detail.img[0]" />
        <div class="right">
          <p>{{detail.title}}</p>
          <div class="ms">购买数量：1次</div>
          <!--<div class="ms"></div>-->
          <div class="price">￥{{price == 0 ? detail.rate : price}}</div>
        </div>
      </div>
    </div>

    <div class="email">
      地址：{{detail.address}}
    </div>

    
    <div class="email">
      预约日期
      <img class="mebg" src="~assets/images/me_jiantou.png" />
      <el-date-picker :picker-options="expireTimeOption" :editable="false" v-model="timer" type="date" format="yyyy-MM-dd" placeholder="请选择日期" @change="dateChange"></el-date-picker>
    </div>

    <div class="email" @click="xuan" v-if="timer != ''">
      时间段
      <img class="mebg" src="~assets/images/me_jiantou.png" />
      <span>{{fl}}</span>
    </div>

    <div style="height:50px"></div>

    <div class="footer1">
      <div class="foot-title">
        <span>1次使用</span>
        <span>￥{{price == 0 ? '0.00' : price}}</span>
      </div>
      <div class="pay" v-if="price > 0" @click="payment">
        <span>提交订单</span>        
      </div>

      <div class="pay" v-if="price <= 0" >
        <span style="background:rgba(0,0,0,.2)">提交订单</span>        
      </div>
    </div>


    <el-drawer
      title="请选择时间段" :visible.sync="drawer" :direction="direction" size="60%" :withHeader="false">
      <h2>时间段</h2>
      <ul>
        <li v-for="(item,i) in detail.cate" :class="curt == i && item.title != order.cate_name ? 'curt' :''" @click="choose(item.price,item.title,i)" :style="detail.check[timer] == undefined  ? '' : (detail.check[timer].toString().indexOf(item.title) == -1 ? '' :'display:none')">
          <span>{{item.title}}<font v-if="str.match(RegExp(item.title))">已约</font></span>
          
        </li>
      </ul>
      <h2>价格</h2>
      <div class="catePrice">
        <span>￥{{catePrice}}</span>
        <font>({{cateName}})</font>
      </div>

      <button @click="yesCate">确认</button>
    </el-drawer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        str:'',
        userData:[],
        order:[],
        drawer:false,
        direction: 'btt',
        timer:'',
        expireTimeOption: {
          disabledDate(date) {
           //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
            return date.getTime() <  Date.now() - 24 * 60 * 60 * 1000;
          }
        },
        cateName:'',
        catePrice:'',
        curt:0,
        price:0,
        fl:'请选择对应时间段'
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      dateChange:function(){
        var that = this;
        var d = new Date(that.timer);
        var m = ((d.getMonth() + 1)<10 ? '0'+(d.getMonth() + 1):(d.getMonth() + 1))
        var r = d.getDate() < 10 ? '0'+d.getDate() :d.getDate();
        var timer = d.getFullYear() + '-' + m + '-' + r;
        if(that.detail.check[timer] == '上午'){
          that.cateName = that.detail.cate[1].title;
          that.catePrice = that.detail.cate[1].price;
        }
      },

      payment:function(){
        var that = this;
        if(that.price == 0){
          return false;
        }
        that.fullscreenLoading = true;
        var id = this.$route.query.id;

        var d = new Date(that.timer);
        var m = ((d.getMonth() + 1)<10 ? '0'+(d.getMonth() + 1):(d.getMonth() + 1))
        var r = d.getDate() < 10 ? '0'+d.getDate() :d.getDate();
        var timer = d.getFullYear() + '-' + m + '-' + r;
        
        this.axios({
          method:'post',
          url:that.$host+'home/lock/save',
          params:{
            id:id,
            user_id:that.userData.id,
            timer:timer,
            cate_name:that.fl,
            price:that.price,
          }
        }).then(function(response){
          if(response.data.status == 200){
            var order_id = response.data.data;
            that.toPush(order_id,'lockPay')
          }else{
            alert(response.data.message)
          }
          
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      choose:function(price,title,i){
        if(!this.str.match(RegExp(title))){
          this.curt = i;
          this.cateName = title;
          this.catePrice = price;
        }

      },

      xuan:function(){
        this.getIsOrder();
      },

      yesCate:function(){
        this.drawer = false;
        var cate = this.detail.cate;
        if(this.curt != 4){
          this.price = cate[this.curt].price;
          this.fl = cate[this.curt].title;

        }else{
          this.price = 0;
          this.fl = '请选择对应时间段';
        }
      },

      getDetail:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/lock/detail',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res;
          that.cateName = res.cate[0].title;
          that.catePrice = res.cate[0].price;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getIsOrder:function(){
        var that = this;
        var id = this.$route.query.id;

        var d = new Date(that.timer);
        var m = ((d.getMonth() + 1)<10 ? '0'+(d.getMonth() + 1):(d.getMonth() + 1))
        var r = d.getDate() < 10 ? '0'+d.getDate() :d.getDate();
        var timer = d.getFullYear() + '-' + m + '-' + r;
        that.timer = timer
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/lock/isOrder',
          params:{
            id:id,
            timer:timer
          }
        }).then(function(response){
          var res = response.data.data;
          that.order = res.order;
          if(res.order.length > 0){
            that.str = res.str;
            var cate = that.detail.cate
            for(var i =0;i<cate.length;i++){
              if(res.str.match(RegExp(cate[i].title))){
                switch(i){
                  case 0 :
                    that.curt = 1;
                    that.cateName = cate[1].title;
                    that.catePrice = cate[1].price;
                    break;
                  case 1 :
                    that.curt = 2;
                    that.cateName = cate[2].title;
                    that.catePrice = cate[2].price;
                    break;
                  case 2 :
                    that.curt = 3;
                    that.cateName = '整天已约满';
                    that.catePrice = '0.00';
                    break;
                }
              }
            }
          }else{
            var c = that.detail

            if(timer == res.timer){
              let date=new Date();
          　　if(date.getHours()>=0&&date.getHours()<12){
          　　　　that.curt = 0;
                  that.cateName = c.cate[0].title;
                  that.catePrice = c.cate[0].price;
          　　}else if(date.getHours()>=12&&date.getHours()<18){
          　　　　that.curt = 1;
                  that.str = c.cate[0].title;
                  that.cateName = c.cate[1].title;
                  that.catePrice = c.cate[1].price;
          　　}else{
          　　　　that.curt = 2;
                  that.str = c.cate[0].title+','+c.cate[1].title;
                  that.cateName = c.cate[2].title;
                  that.catePrice = c.cate[2].price;
          　　}
            }else{
              that.curt = 0;
              that.cateName = c.cate[0].title;
              that.catePrice = c.cate[0].price;
              that.str = '';
              if(that.detail.check[timer] == '上午'){
                that.cateName = that.detail.cate[1].title;
                that.catePrice = that.detail.cate[1].price;
                that.curt = 1;
              }
            }
            
          }
          that.fullscreenLoading = false;

          that.drawer = true;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .yespro{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-bottom:5px
  }
  .yespro .address{
    background:#fff;
    display:block;
    padding:2% 0 6% 0;
    margin-bottom:8px
  }
  .yespro .address:after,.yespro .goods:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .yespro .address .left{
    float:left;
    width:25%;
    text-align:center;
    margin-top:4%
  }

  .yespro .address .left span{
    display:block;
    padding-bottom:8px;
    font-size:15px;
  }
  .yespro .address .left font{
    background:rgba(255,0,0,.8);
    color:#fff;
    padding:3px 8px;
    font-size:14px;
  }
  .yespro .address .right{
    float:left;
    width:60%;
    margin-left:2%;
    margin-top:4.5%
  }
  .yespro .address .right span{
    display:block;
    font-size:16px;
    padding-bottom:8px;
  }
  .yespro .address img{
    float:left;
    width:10px;
    margin:7% 0 0 4%
  }

  .yespro .pro{
    background:#fff;
    display:block;
    width:94%;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin:15px auto;

  }
  .yespro .pro h2{
    height:50px;
    border-bottom:solid 1px #f1f1f1;
    line-height:50px;
    font-weight:normal;
    padding:0 20px;
    font-size:16px;
  }
  .yespro .pro h2 span{
    float:right;
    font-size:14px;
    color:#555
  }
  .yespro .goods .left{
    float:left;
    width:30%;
    border-radius:5px;
    margin:4% 2% 4% 4%
  }
  .yespro .goods .right{
    float:left;
    margin-top:4%;
    width:60%
  }
  .yespro .goods .right p{
    font-weight:bold;
    letter-spacing:1px;
    font-size:15px;
  }
  .yespro .goods .right .ms{
    font-size:15px;
    color:#999;
    padding:13px 0
  }
  .yespro .goods .right .price{
    color:#FF6600;
    font-size:15px;
    font-weight:bold
  }
  .yespro .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }
  .yespro textarea{
    display:block;
    width:86%;
    margin:0 auto;
    height:60px;
    border:none;
    background:#f5f5f5;
    border-radius:5px;
    padding:2%;
    font-size:15px;
    outline:none;
  }

  .yespro .remark{
    display:block;
    width:92%;
    color:#f00;
    font-size:14px;
    letter-spacing:1px;
    margin:0 auto;
    padding:10px 0 15px 0
  }

  .yespro .email{
    height:50px;
    background:#fff;
    line-height:50px;
    margin-top:8px;
    padding:0 4%;
    font-size:15px;
    color:#333;
    width:86%;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin:15px auto;
  }
  .yespro .email .el-date-editor.el-input{
    float:right;
    width:50%;
  }
  .yespro .email .el-input--suffix .el-input__inner{
    padding:0
  }
  .yespro .email .el-date-editor.el-input input{
    border:none;
    text-align:right;
    cursor: pointer;
  }
  .yespro .email .el-date-editor.el-input span{
    display:none;
  }
  .yespro .email span{
    float:right;
    color:#999;
    font-size:14px;
  }
  .yespro .email img{
    float:right;
    width:8px;
    margin-left:10px;
    margin-top:19px
  }

  .footer1{
    height: 50px;
    background: #fff;
    width: 94%;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    position: fixed;
    bottom: 10px;
    left: 3%;
    z-index: 1
  }
  .yespro .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .yespro .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
    margin-right:15px;
  }
  .yespro .footer1 .foot-title span:last-child{
    font-size: 16px;
    color: #FF6600;
    position: relative;
    left: -4rpx;
    font-weight: bold
  }
  .yespro .footer1 .foot-title span b{
    color: #FF6600;
    font-size:17px;
    font-weight:500;
  }
  .yespro .footer1 .foot-title span i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }

  
  .yespro .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .yespro .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #FF751A;
    border-radius:40px;
  }

  .yespro .el-drawer h2{
    font-size:15px;
    padding:20px 0 10px 20px;
  }
  .yespro .el-drawer ul:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .yespro .el-drawer li{
    float:left;
    width:30%;
    text-align:center;
    height:50px;
    line-height:50px;
  }
  .yespro .el-drawer li span{
    background:rgba(0,0,0,.02);
    border-radius:40px;
    font-size:13px;
    color:#555;
    padding:5px 15px 
  }
  .yespro .el-drawer li.curt span{
    background:rgba(255,0,0,.1);
    color:#f00
  }
  .yespro .el-drawer .catePrice{
    font-size:15px;
    padding:0px 0 80px 25px;
    letter-spacing:1px;
  }
  .yespro .el-drawer .catePrice span{
    font-weight:bold;
    color:#f00;
  }
  .yespro .el-drawer .catePrice font{
    color:#666;
    padding-left:5px
  }
  .yespro .el-drawer button{
    width:85%;
    margin:0 auto;
    height:40px;
    background:#f00;
    color:#fff;
    text-align:center;
    line-height:40px;
    font-size:15px;
    border-radius:40px;
    display:block;
    border:none;

  }
</style>